export const uid = () => Math.random().toString(36).slice(2, 10);

export const TEMPLATES = [
  { id: "modern", name: "Modern", blurb: "Clean sans-serif with a gold accent rule", accent: [180, 140, 40] },
  { id: "professional", name: "Professional", blurb: "Centered serif header, classic rules", accent: [30, 41, 59] },
  { id: "minimal", name: "Minimal", blurb: "Quiet black and white, lots of air", accent: [60, 60, 60] },
  { id: "creative", name: "Creative", blurb: "Bold color header band", accent: [124, 58, 237] },
  { id: "healthcare", name: "Healthcare", blurb: "Calm teal headers, credentials first", accent: [13, 148, 136] },
];
export const templateById = (id) => TEMPLATES.find((t) => t.id === id) || TEMPLATES[0];

export const EMPTY = {
  personal: { full_name: "", title: "", email: "", phone: "", location: "", linkedin: "", website: "" },
  summary: "",
  experience: [],
  education: [],
  skills: [],
  certifications: [],
};

export const NEW_ITEM = {
  experience: () => ({ id: uid(), role: "", company: "", location: "", start: "", end: "", current: false, bullets: [""] }),
  education: () => ({ id: uid(), degree: "", school: "", location: "", start: "", end: "", details: "" }),
  certifications: () => ({ id: uid(), name: "", issuer: "", date: "" }),
};

const str = (v) => (v == null ? "" : String(v));
const arr = (v) => (Array.isArray(v) ? v : []);
const lines = (v) => (Array.isArray(v) ? v.map(str) : str(v).split(/\n+/)).map((s) => s.replace(/^[•\-*]\s*/, "").trim()).filter(Boolean);

export const normalize = (r = {}) => {
  const p = r.personal || r.personal_info || r.contact || {};
  return {
    personal: Object.fromEntries(Object.keys(EMPTY.personal).map((k) => [k, str(p[k] ?? (k === "full_name" ? p.name : k === "title" ? p.headline : ""))])),
    summary: str(r.summary || r.profile),
    experience: arr(r.experience || r.work_experience).map((e) => ({
      ...NEW_ITEM.experience(), ...e, id: e.id || uid(), role: str(e.role || e.title || e.position), company: str(e.company || e.employer),
      start: str(e.start || e.start_date), end: str(e.end || e.end_date), current: !!e.current,
      bullets: (() => { const b = lines(e.bullets || e.highlights || e.description); return b.length ? b : [""]; })(),
    })),
    education: arr(r.education).map((e) => ({ ...NEW_ITEM.education(), ...e, id: e.id || uid(), degree: str(e.degree), school: str(e.school || e.institution), start: str(e.start || e.start_date), end: str(e.end || e.end_date || e.year), details: str(e.details || e.description) })),
    skills: arr(r.skills).map((s) => str(typeof s === "object" ? s.name : s)).filter(Boolean),
    certifications: arr(r.certifications).map((c) => (typeof c === "string" ? { ...NEW_ITEM.certifications(), name: c } : { ...NEW_ITEM.certifications(), ...c, id: c.id || uid(), name: str(c.name || c.title), issuer: str(c.issuer || c.organization), date: str(c.date || c.year) })),
  };
};

export const dates = (e) => [e.start, e.current ? "Present" : e.end].filter(Boolean).join(" – ");
export const contactLine = (p) => [p.email, p.phone, p.location, p.linkedin, p.website].filter(Boolean);
export const cleanBullets = (b) => (b || []).map((x) => x.trim()).filter(Boolean);
const slug = (s) => (s || "").replace(/[^\w]+/g, "_").replace(/^_+|_+$/g, "");
export const fileName = (r, job) => `${slug(r.personal.full_name) || "My"}_Resume${job ? `_${[slug(job.company), slug(job.title)].filter(Boolean).join("_").slice(0, 60)}` : ""}.pdf`.replace(/_+/g, "_");

export const SAMPLE = normalize({
  personal: { full_name: "Jordan Avery", title: "Senior Product Manager", email: "jordan@email.com", phone: "(555) 010-2030", location: "Austin, TX", linkedin: "linkedin.com/in/jordanavery" },
  summary: "Product leader with 8 years shipping B2B SaaS. Grew activation 34% and led teams of 12 across design and engineering.",
  experience: [
    { role: "Senior Product Manager", company: "Northwind", start: "2021", current: true, bullets: ["Launched AI onboarding that lifted activation 34%", "Owned $12M roadmap across three squads"] },
    { role: "Product Manager", company: "Contoso", start: "2017", end: "2021", bullets: ["Shipped billing revamp cutting churn 11%"] },
  ],
  education: [{ degree: "B.S. Information Systems", school: "UT Austin", end: "2016" }],
  skills: ["Roadmapping", "SQL", "A/B testing", "Stakeholder management", "Figma"],
  certifications: [{ name: "Certified Scrum Product Owner", issuer: "Scrum Alliance", date: "2022" }],
});
